import React from 'react'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import Services from '../services/Services'
import K from '../services/k'
import { useEffect, useState } from 'react'

export function Cart(props) {
  const resinfo = props.resinfo

  const services = new Services(this)
  const [cart, setcart] = useState([])

  useEffect(() => {
    fetchcart().then((x) => {})
  }, [props.onChange])

  //fetch total
  const [carttotal, setcarttotal] = useState(0)

  const fetchcart = async () => {
    const data = {
      apiToken: services.token,
      client_id: services.user_id,
    }
    //
    let resp
    try {
      resp = await Axios.post(`${K.baseUrl}cart`, data)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    setcart(resp?.data?.cartitems)
    if (resp.data.order) {
      setcarttotal(resp.data.order[0].total)
    }
  }

  const removecart = async (id) => {
    const data = {
      apiToken: services.token,
      client_id: services.user_id,
      item_id: id,
    }
    var resp
    try {
      resp = await Axios.post(`${K.baseUrl}deletecart`, data)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (resp.data.resultcode === 1) {
      fetchcart()
    } else {
      fetchcart()
    }
  }

  const renderOptions = (options) => {
    try {
      options = JSON.parse(options)
    } catch (error) {
      return null
    }
    var optionCount = 0
    // var newOptions = [];
    options.forEach((option) => {
      var newOptionItems = []
      if (option.option_items && option.option_items.length > 0) {
        option.option_items.forEach((option_item) => {
          if (option_item.selected === 1) {
            newOptionItems.push(option_item)
            optionCount++
          }
        })
      }
      option.option_items = newOptionItems
    })
    if (optionCount === 0) {
      return null
    }

    return (
      <div>
        <span>Options</span>
        {options.map((option, index) => (
          <div key={index}>
            <div style={{ marginLeft: 30 }} key={option.option}>
              <b className="mr-2">{option.option}:</b>
              {option.option_items.map((option_item) => (
                <span key={option_item.name}>
                  {option_item.name} +${option_item.add_price}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="col-lg-3 col-md-12 col-sm-12">
      {resinfo !== null && (
        <div>
          {!cart ? (
            <div className="your-order-card">
              <div className="card-head">
                <h5>Your Cart is empty</h5>
                <p className="normalText Spaced">
                  You&apos;ve not made any orders yet.
                </p>
                <img
                  src="/emptycart.svg"
                  className="img img-responsive Spaced"
                />
                <p className="normalText Spaced">
                  When you Order, they&apos;ll appear here!
                </p>
              </div>
            </div>
          ) : cart?.length < 1 ? (
            <div className="your-order-card">
              <div className="card-head">
                <h5>Your Cart is empty</h5>
                <p className="normalText Spaced">
                  You&apos;ve not made any orders yet.
                </p>
                <img
                  src="/emptycart.svg"
                  className="img img-responsive Spaced"
                />
                <p className="normalText Spaced">
                  Once you order, your recent orders will appear here...
                </p>
              </div>
            </div>
          ) : (
            <div className="your-order-card">
              <div className="card-head">
                <h4 className={'text-center mb-3'}>Your Order</h4>
                <h4 className={'text-success mb-2'}>{resinfo.rname}</h4>
              </div>
              <div className="order-listing">
                <ul>
                  {cart
                    ? cart.map((cartitem, index) => (
                        <li key={index}>
                          <p>
                            <span style={{ width: 100 }}>
                              {cartitem.quantity}x
                            </span>{' '}
                            {cartitem.meal_name}
                          </p>
                          <p>
                            <span style={{ width: 100 }}>JMD</span>
                            <b>${cartitem.price}</b>
                          </p>
                          <p>
                            <span style={{ width: 100 }}>Size</span>{' '}
                            <b>{cartitem.size}</b>
                          </p>
                          {cartitem.options && renderOptions(cartitem.options)}
                          <button onClick={removecart.bind(this, cartitem.id)}>
                            Remove
                          </button>
                        </li>
                      ))
                    : ''}
                </ul>
              </div>
              <Link
                to={{
                  pathname: `/checkout`,
                  state: { resinfo },
                }}
              >
                <button type="button" className="btn primary-btn">
                  <span>Checkout </span>
                  <span>JMD ${carttotal}</span>
                </button>
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
